<template>
    <vx-expandable-card>
        <template v-slot:content>
            <vx-badge color="violet" size="sm" class="px-2!">
                Optional
                <font-awesome-icon widthAuto :icon="faPencilSlash"></font-awesome-icon>
            </vx-badge>
            <h3 class="mt-2 text-xl text-slate-700 font-extrabold">Subscription Status</h3>
            <p class="text-sm">
                How should we update the marketing and transactional subscription statuses on this import?
            </p>

            <div class="my-4 grid gap-6 lg:grid-cols-2 lg:gap-8">
                <div>
                    <div class="text-slate-700 text-base font-extrabold mb-1">Marketing</div>
                    <vx-radio-selection v-model="marketing" @update:modelValue="updateModelValue()">
                        <vx-radio-selection-item
                            v-for="option in options"
                            :key="`marketing-${option.key}`"
                            :value="option.value"
                        >
                            {{ option.label }}
                        </vx-radio-selection-item>
                    </vx-radio-selection>
                </div>
                <div>
                    <div class="text-slate-700 text-base font-extrabold mb-1">Transactional</div>
                    <vx-radio-selection v-model="transactional" @update:modelValue="updateModelValue()">
                        <vx-radio-selection-item
                            v-for="option in options"
                            :key="`transactional-${option.key}`"
                            :value="option.value"
                        >
                            {{ option.label }}
                        </vx-radio-selection-item>
                    </vx-radio-selection>
                </div>
            </div>

            <vx-alert color="info" :closeable="false"> Values in the CSV will override these options. </vx-alert>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import { VxAlert, VxExpandableCard, VxBadge, VxRadioSelection, VxRadioSelectionItem } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref, watch } from 'vue';
import {
    CONTACT_SUBSCRIPTION_STATUS_OPT_IN,
    CONTACT_SUBSCRIPTION_STATUS_OPT_OUT,
    CONTACT_SUBSCRIPTION_TYPE_MARKETING,
    CONTACT_SUBSCRIPTION_TYPE_TRANSACTIONAL,
} from '~/constants/contactSubscription';

const options = [
    {
        label: 'Do nothing',
        value: null,
    },
    {
        label: 'Opt-in',
        value: CONTACT_SUBSCRIPTION_STATUS_OPT_IN,
    },
    {
        label: 'Opt-out',
        value: CONTACT_SUBSCRIPTION_STATUS_OPT_OUT,
    },
];

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(['update:modelValue']);

const marketing = ref(null);
const transactional = ref(null);

watch(
    () => props.modelValue,
    (subscriptions) => {
        subscriptions.forEach((subscription) => {
            if (subscription.type === CONTACT_SUBSCRIPTION_TYPE_MARKETING) {
                marketing.value = subscription.status;
            }
            if (subscription.type === CONTACT_SUBSCRIPTION_TYPE_TRANSACTIONAL) {
                transactional.value = subscription.status;
            }
        });
    },
    {
        immediate: true,
    }
);

const updateModelValue = () => {
    const subscriptions = [];

    if (transactional.value) {
        subscriptions.push({
            type: CONTACT_SUBSCRIPTION_TYPE_TRANSACTIONAL,
            status: transactional.value,
        });
    }

    if (marketing.value) {
        subscriptions.push({
            type: CONTACT_SUBSCRIPTION_TYPE_MARKETING,
            status: marketing.value,
        });
    }

    emit('update:modelValue', subscriptions);
};
</script>
